import React from "react";
import { Phone, MessageCircle, Clock, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PHONE, PHONE_RAW } from "@/i18n/translations";
import { SectionLabel, MaskedHeading, Reveal } from "@/components/site/Motion";

export const Contact = () => {
  const { t } = useLang();

  const cards = [
    { icon: Clock, label: t.contact.hours, value: t.contact.hoursValue },
    { icon: MapPin, label: t.contact.address, value: t.contact.addressValue },
  ];

  return (
    <section id="contact" className="py-24 md:py-36 px-6 md:px-12 relative overflow-hidden">
      <div className="absolute left-1/3 top-0 w-[500px] h-[500px] ambient-glow blur-3xl pointer-events-none opacity-50" />
      <div className="max-w-[1600px] mx-auto relative">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="flex justify-center">
            <SectionLabel>{t.contact.overline}</SectionLabel>
          </div>
          <h2 className="font-heading text-4xl md:text-7xl text-white tracking-tight">
            <MaskedHeading text={t.contact.title} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-5 font-body text-white/60">{t.contact.desc}</p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-14">
            <a
              data-testid="contact-call"
              href={`tel:+${PHONE_RAW}`}
              className="group inline-flex items-center justify-center gap-3 bg-brand hover:bg-brand-light text-white font-body px-9 py-5 transition-colors"
            >
              <Phone size={18} />
              <span>{t.contact.callText} — {PHONE}</span>
            </a>
            <a
              data-testid="contact-whatsapp"
              href={`https://wa.me/${PHONE_RAW}`}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-3 border border-white/20 hover:border-brand text-white hover:text-brand font-body px-9 py-5 transition-colors"
            >
              <MessageCircle size={18} />
              <span>{t.contact.whatsappText}</span>
            </a>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
          {cards.map((c, i) => (
            <Reveal key={i} delay={0.2 + i * 0.1}>
              <div className="bg-surface border border-white/5 hover:border-brand/40 transition-colors p-8 flex items-start gap-5">
                <span className="text-brand mt-1"><c.icon size={22} /></span>
                <div>
                  <p className="font-body text-xs uppercase tracking-widest text-white/50 mb-1">{c.label}</p>
                  <p className="font-heading text-2xl text-white">{c.value}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
